
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as LittleGroupRegisterIconComponent } from "./little-group-register-icon.svg";

export const LittleGroupRegisterIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <LittleGroupRegisterIconComponent {...props} />;
};
